// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"dbb262bb","139":"a216828e","319":"13931109","580":"01fa238b","613":"ae82ba33","682":"bc05efc7","981":"2946b11a"}[chunkId] + ".chunk.css";
};